<div #script="" style.display="none">
    <ng-content></ng-content>
</div>